/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { METRIC_SOURCE, METRIC_COUNTING, METRIC_TYPE } from '../../constants/okrPopUp.constants';
import KrService from '../../services/kr.service';

const service = new KrService();

const MetricOtherGoal = (props: any) => {
    const { metricId } = props;
    const [isOpen, changeSts] = useState([]);
    const [rollupData, setRollupData] = useState([]);
    const [gfgCount, setGoalFromGoalCount] = useState('');
    const { t } = useTranslation();
    const getRollUpOkrCount = () => {
        const params = {
            metricId, api: false, withMetric: false, OkrCount: true
        };
        service.getMetricGoals(params)
            .then((response) => {
                setGoalFromGoalCount(response.data.data);
            })
            .catch((err: any) => {
                console.log('err', err);
            });
    }

    useEffect(() => {
        const contentId = document.getElementById('content');
        showLoaderWidget(contentId);
        const params = { metricId, api: false, withMetric: false };
        service.getMetricGoals(params)
            .then((response) => {
                setRollupData(response.data.data);
                removeLoader();
            })
            .catch((err: any) => {
                removeLoader();
                console.log('err', err);
            });
        getRollUpOkrCount();
    }, [metricId]);
    const manageHideShow = (goalId) => {
        const idx = $.inArray(goalId, isOpen);
        if (idx === -1) {
            changeSts((prevArray) => [...prevArray, goalId]);
        } else {
            const newArray = [...isOpen];
            newArray.splice(idx, 1);
            changeSts(newArray);
        }
    }
    const clickGoalRow = (e, goal, type = null) => {
		e.stopPropagation();
		e.preventDefault();
		let params = { id: goal.id};
        if (type == 'align') {
        params['t'] = 'alignspopup' ;
        }
		viewGoalDetailsPage($(e.target), params);
	}
    const openOkrDeatilsPage = () => {
        const url = `${wbConfig.baseUrl}/goal/krDetails?id=${metricId}`
        window.open(url);
    }

    return (
        <div className="metric_other_goal_wrap">
            <div className="goal-chart-title " role="heading" aria-level={2}>
            {t('Overall progress on these objectives')}
            </div>
            <div className="goal-charts">
                <div className="formatSection" dangerouslySetInnerHTML={{ __html: gfgCount }} />
                <a
                    href="javascript:;"
                    className="kr-buttons resultDetails clickable"
                    ref-src="OKR_DETAILS"
                    data-metric-id={metricId}
                    style={{ color: '#2c9ab7', fontSize: '12px' }}
                >{t('View update history')}
                </a>

                <a
                    href="javascript:;"
                    className="kr-buttons view-results-details-button"
                    metric-id={metricId}
                    onClick={openOkrDeatilsPage}
                >
                    {t('View results details')}
                </a>
            </div>

            {
                rollupData && Object.keys(rollupData).map((g: any, index: any) =>
                    <div className="metric-other-goal-table" key={`table-${index}`}>
                        <div className="metrc-other-goal-row   " data-goal-id={rollupData[g].id}>
                            <div className="metrc-other-goal-table-col other-goal-target-wrap">
                                <span
                                    className="other-goal-metrc-achive"
                                    style={{ color: rollupData[g].progress_color }}
                                >
                                    {(rollupData[g].progress >= 0) ? `${rollupData[g].progress}%` : '--'}
                                </span>
                            </div>
                            <div className="metrc-other-goal-table-co other-goal-name-wrap" onClick={(e) => clickGoalRow(e, rollupData[g])}>
                                <div className="metrc-other-goal-name">{rollupData[g].goal}</div>
                                {(rollupData[g].teamName.length > 0) ? (
                                    <div className="truncateText team-ownr-name">
                                        {rollupData[g].teamName}: {rollupData[g].ownerFullName}
                                    </div>
                                ) : (
                                    <div className="truncateText team-ownr-name">
                                        {rollupData[g].ownerFullName}
                                    </div>
                                )}
                            </div>
                            {rollupData[g].goal_metric && Object.keys(rollupData[g].goal_metric).length
                                && (
                                    <div
                                        role="button"
                                        tabIndex={0}
                                        className="metrc-other-goal-table-col other-goal-link-wrap"
                                        onClick={(e) => manageHideShow(rollupData[g].id)}
                                        onKeyDown={(e) => manageHideShow(rollupData[g].id)}
                                    >
                                        <span className="metrc-other-goal-link">
                                            {$.inArray(rollupData[g].id, isOpen) > -1 ? 'Hide ' : 'Show '}
                                            {t('Key Results')}
                                        </span>
                                    </div>
                                )}
                        </div>
                        {
                            isOpen.includes(rollupData[g].id)
                                && rollupData[g].goal_metric
                                && Object.keys(rollupData[g].goal_metric).map((m) =>
                                    <div
                                        className="other-goal-metric-row-wrap metrc-other-goal-row"
                                        data-goal-id={rollupData[g].id}
                                    >
                                        <div
                                            className="
                                                metrc-other-goal-table-col emapty-in-metric-row  emapty-in-metric-row
                                            "
                                        />
                                        <div className="metrc-other-goal-table-col metrc-data-row">
                                            <div className="metric-other-goal-table no-border">
                                                <div className="metrc-other-goal-row">
                                                    <div className="metrc-other-goal-table-col">
                                                        <div className="metrci-target">
                                                        {
                                                            (
                                                                (rollupData[g].goal_metric[m].source
                                                                    == METRIC_SOURCE.SOURCE_PERSON
                                                                        && rollupData[g].goal_metric[m].counting
                                                                            == METRIC_COUNTING.METRIC_COUNTING_RANGE
                                                                )
                                                                || (rollupData[g].goal_metric[m].source
                                                                    == METRIC_SOURCE.SOURCE_DATA_STREAMS
                                                                        && rollupData[g].goal_metric[m].counting
                                                                            == METRIC_COUNTING.METRIC_COUNTING_RANGE
                                                                )
                                                                || (rollupData[g].goal_metric[m].source
                                                                    == METRIC_SOURCE.SOURCE_METRICS
                                                                        && rollupData[g].goal_metric[m].type
                                                                            == METRIC_TYPE.TYPE_CASCADE
                                                                        && rollupData[g].goal_metric[m].counting
                                                                            == METRIC_COUNTING.METRIC_COUNTING_RANGE
                                                                )
                                                                || (rollupData[g].goal_metric[m].source
                                                                    == METRIC_SOURCE.SOURCE_SURVEY
                                                                        && rollupData[g].goal_metric[m].counting
                                                                            == METRIC_COUNTING.METRIC_COUNTING_SURVEY_SCALE
                                                                )
                                                            )
                                                                ? (
                                                                    <>
                                                                        <span
                                                                            style={{
                                                                                color: rollupData[g]
                                                                                    .goal_metric[m]
                                                                                    .metric_progress_color
                                                                            }}
                                                                        >
                                                                            {rollupData[g].goal_metric[m].achieve_target}
                                                                        </span>
                                                                        <span>
                                                                            {rollupData[g].goal_metric[m].targetDisplay
                                                                                ? ' of '
                                                                                : ''}
                                                                            {rollupData[g].goal_metric[m].targetDisplay
                                                                                ? `${rollupData[g].goal_metric[m].lower_limit}
                                                                                    -${
                                                                    rollupData[g]
                                                                        .goal_metric[m]
                                                                        .upper_limit
                                                                    }
                                                                                `
                                                                                : ''}
                                                                        </span>
                                                                    </>
                                                                )
                                                                : (
                                                                    <>
                                                                        <span
                                                                            style={{
                                                                                color: rollupData[g]
                                                                                    .goal_metric[m]
                                                                                    .metric_progress_color
                                                                            }}
                                                                        >
                                                                            {rollupData[g].goal_metric[m].achieveTarget}
                                                                        </span>
                                                                        <span>
                                                                            {
                                                                                rollupData[g].goal_metric[m].targetDisplay
                                                                                    ? ' of '
                                                                                    : ''
                                                                            }
                                                                            {
                                                                                rollupData[g].goal_metric[m].targetDisplay
                                                                                    ? rollupData[g].goal_metric[m].totalTarget
                                                                                    : ''
                                                                            }
                                                                        </span>
                                                                    </>
                                                                )
                                                        }
                                                        </div>
                                                    </div>
                                                    <div className="metrc-other-goal-table-col other-goal-name-wrap">
                                                        <div className="metrc-data-name">{rollupData[g].goal_metric[m].name}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>)
                        }
                    </div>)
            }
        </div>
    )
}

export default MetricOtherGoal;
